import { createSelector, createStructuredSelector } from 'reselect';
import memoize from 'lodash.memoize';

export default function byIdSelectorFactory(rootApi, resourceKey) {
  return memoize(function (callable) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$getId = _ref.getId,
        getId = _ref$getId === undefined ? null : _ref$getId,
        _ref$dereference = _ref.dereference,
        dereference = _ref$dereference === undefined ? false : _ref$dereference;

    return function (state, props) {
      var id = getId ? getId(props) : props ? props.id : null;
      if (!id) {
        // @todo invariant.
        return {
          fetched: false,
          error: true,
          errorMessage: 'No ID found on resource'
        };
      }

      if (dereference && (!state.dereferenced || !state.dereferenced[id])) {
        return {
          fetched: false,
          loading: false
        };
      }

      if (!state.resources || !state.resources[resourceKey] || !state.resources[resourceKey][id]) {
        return {
          fetched: false,
          loading: true
        };
      }

      var selectorOrStructure = callable(rootApi(function (s) {
        return s.resources[resourceKey][id];
      }));

      var newProps = (selectorOrStructure && {}.toString.call(selectorOrStructure) === '[object Function]' ? function (selector) {
        return function (passThroughState) {
          return selector(passThroughState);
        };
      } : createStructuredSelector)(selectorOrStructure)(state);

      return newProps;
    };
  });
}